import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from 'classnames';
import React from "react";
import Modal from '../popups/Modal';
/**
 * @deprecated
 * This is a extended version of modal. this covers the full UI.
 * main purpose is to create a container for sidebar link widgets
 * @example
 * ```
 *  <button className="btn showcase" onClick={() => setShowLinkWidget(true)}>Click to Show Link Widget Container</button>
 *
 *  <LinkWidgetContainer
 *      show={showLinkWidget}
 *      onClose={() => setShowLinkWidget(false)}
 *      title="Link Widget Container"
 *  >
 *      content
 * </LinkWidgetContainer>
 * ```
 * @export
 *
 */
const LinkWidgetContainer = (props) => {
    // state
    let [show, setShow] = React.useState(props.show);
    // update state
    React.useEffect(() => {
        setShow(props.show);
    }, [props.show]);
    // on open callback
    const onOpen = () => {
        if (typeof props.onOpen == "function") {
            props.onOpen();
        }
    };
    // on close callback
    const onClose = () => {
        setShow(false);
        if (typeof props.onClose == "function") {
            props.onClose();
        }
    };
    // get class name
    let className = classNames("full-widget", props.className);
    return (_jsxs(Modal, { show: show, onOpen: onOpen, onClose: onClose, className: className, title: typeof props.title != 'undefined' && props.title, children: [typeof props.toolbarContent != "undefined" &&
                _jsx("div", { className: "toolbar", children: props.toolbarContent }), _jsx("div", { className: `content`, children: props.children })] }));
};
export default LinkWidgetContainer;
